import { Progress } from "@/components/ui/progress";
import { Loader2 } from "lucide-react";

interface TranslationProgressIndicatorProps {
  alreadyTranslated: number;
  totalQuestions: number;
  currentBatch?: number;
  totalBatches?: number;
  isTranslating: boolean;
}

export function TranslationProgressIndicator({ 
  alreadyTranslated, 
  totalQuestions,
  currentBatch,
  totalBatches,
  isTranslating
}: TranslationProgressIndicatorProps) {
  const percentComplete = totalQuestions > 0 
    ? Math.round((alreadyTranslated / totalQuestions) * 100) 
    : 0;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Translation Progress</span>
        <span className="font-medium">{percentComplete}% ({alreadyTranslated} of {totalQuestions})</span>
      </div>
      
      <Progress value={percentComplete} className="h-2" />
      
      {isTranslating && currentBatch !== undefined && totalBatches !== undefined && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Processing batch {currentBatch} of {totalBatches}</span>
        </div>
      )}
      
      <div className="space-y-1 text-sm">
        <div className="flex items-center gap-2">
          <span className="text-green-600">✓</span>
          <span className="text-muted-foreground">Already translated: {alreadyTranslated} questions</span>
        </div>
        
        {!isTranslating && totalQuestions - alreadyTranslated > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-yellow-600">○</span>
            <span className="text-muted-foreground">Remaining: {totalQuestions - alreadyTranslated} questions</span>
          </div>
        )}
        
      {isTranslating && (
          <div className="flex items-center gap-2">
            <Loader2 className="h-3 w-3 animate-spin text-blue-600" />
            <span className="text-muted-foreground">Translating in progress...</span>
          </div>
        )}
      </div>
      
      {!isTranslating && totalQuestions - alreadyTranslated > 0 && (
        <p className="text-xs text-muted-foreground mt-2">
          Estimated time: ~{Math.ceil((totalQuestions - alreadyTranslated) / 25 * 0.5)}-{Math.ceil((totalQuestions - alreadyTranslated) / 25 * 0.75)} minutes
        </p>
      )}
    </div>
  );
}
